import { InjectionToken } from '@angular/core';
import { BaseAccountService } from 'core/models/base-account-service.model';

export const BASE_ACCOUNT_SERVICE_TOKEN = new InjectionToken<BaseAccountService>(
  'BASE_ACCOUNT_SERVICE_TOKEN'
);
